// src/app/core/navbar/navbar.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'] // 确保引入了 CSS 文件
})
export class NavbarComponent {

  constructor(public translate: TranslateService) {} // public 使模板可以访问 translate.currentLang

  switchLang(lang: string): void {
    this.translate.use(lang);
  }
}